// import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { AuthContextProvider } from "./components/dashboard/store/AuthContextProvider";
import DemoBanner from "./demo/DemoBanner";
import { installDemoMode } from "./demo";
import reportWebVitals from "./reportWebVitals";
// css
import "./assets/css/index.css";
import "./fontAwesome";

// Inert until someone logs in with the demo credentials; real traffic is untouched.
installDemoMode();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Router>
      <AuthContextProvider>
        <App />
        <DemoBanner />
      </AuthContextProvider>
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
